import script from "./edit-ovr.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-ovr.vue?vue&type=script&setup=true&lang=js"

import "./edit-ovr.vue?vue&type=style&index=0&id=daa2a878&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daa2a878"]])

export default __exports__